module.exports = __webpack_public_path__ + "img/lu.2585715a.svg";